<template>
    <v-menu offset-y max-height="300px" v-if="selectedSale">
        <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize grey--text text--darken-1 mr-2" text dark v-on="on">
                <template v-if="selectedSale">
                    <v-chip color="grey darken-1" label small>
                        {{ selectedChipText }}
                    </v-chip>
                </template>

                <v-icon right> fas fa-caret-down </v-icon>
            </v-btn>
        </template>

        <v-list style="min-width: 0;">
            <v-list-item v-for="sale of $store.state.application.sales" :key="sale.id"
                @click="$store.commit('application/setSelectedSale', sale);">
                <v-list-item-content>
                    <v-list-item-title>
                        <div v-for="(product, i) of getMainProducts(sale)" :key="product.id">
                            {{ product.reference }} -
                            {{ product.typeLabel }}
                            {{ product.roomsLabel }}

                            <template v-if="i < product.length">
                                <br>
                            </template>
                        </div>
                    </v-list-item-title>

                    <v-list-item-subtitle>
                        {{ sale.program.title }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'SalesMenu',

    methods: {
        getMainProducts(sale) {
            if (this.doesntHaveMainProducts(sale)) {
                return sale.products;
            } else {
                return sale.products.filter(p => p.main === 1);
            }
        },

        doesntHaveMainProducts(sale) {
            return sale.products.every((p) => p.main !== 1);
        }
    },

    computed: {
        selectedChipText() {
            let text = `${this.selectedSale.product.reference} - ${this.selectedSale.product.typeLabel} ${this.selectedSale.product.roomsLabel}`;

            let products = [];
            if (this.doesntHaveMainProducts(this.selectedSale)) {
                products = this.selectedSale.products;
            } else {
                products = this.getMainProducts(this.selectedSale);
            }

            if (products.length > 1) {
                text = products.map((p) => p.reference).join(' - ');
            }

            return text;
        }
    }
};
</script>